export enum ButtonAppearance {
    FLAT = 'flat',
    SOLID = 'solid',
    OUTLINE = 'outline',
}
